import axios from 'axios';
import config from '@/utils/config';

const LOGIC_STARS_KEY = config.get('logicStarsKey');

const instance = axios.create({
  baseURL: config.get('logicStarsApi'),
});

export type TValidateVinParams = {
  vin: string;
};

export type TValidateVinResponse = {
  ErrorInfo: string;
  UserInfo: string;
};

export function validateVinNumber(params: TValidateVinParams) {
  return instance.get<TValidateVinResponse>(`/CheckInfo/ValidateVinNumber`, {
    params: {
      key: LOGIC_STARS_KEY,
      ...params,
    },
  });
}

export type TValidatePromocodeParams = {
  promocode: string;
};

export type TValidatePromocodeResponse = {
  ErrorInfo: string;
  UserInfo: string;
};

export function validatePromocode(params: TValidatePromocodeParams) {
  return instance.get<TValidatePromocodeResponse>(`/CheckInfo/ValidatePromocode`, {
    params: {
      key: LOGIC_STARS_KEY,
      ...params,
    },
  });
}

export default instance;
